import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Button, Input } from "../Form";
import { HiOutlineCheckCircle } from "react-icons/hi";
import { toast } from "react-hot-toast";
import userApi from "../../api/user/user.api";

function ChangePassword() {
  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string().required("Old password is required"),
      newPassword: Yup.string()
        .min(2, "New password must be at least 3 characters")
        .required("New password is required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
        .required("Confirm password is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      console.log({ values });
      try {
        const response = await userApi.passwordUpdate({
          oldPassword: values.oldPassword,
          newPassword: values.newPassword,
        });
        const message = response?.data?.message;
        const success = response?.data?.success;

        if (!success) {
          toast.error(message || "Something went wrong");
        } else {
          toast.success(message || "Password updated successfully");
          resetForm();
        }
      } catch (error) {
        const message = error.response?.data?.message || "Update failed";
        toast.error(message);
      }
      // try {
      //   const respone = await userApi.passwordUpdate({
      //     oldPassword: values.oldPassword,
      //     newPassword: values.newPassword,
      //   });

      //   if (respone.status === 400) {
      //     toast.error(respone?.data?.message);
      //   } else {
      //     toast.success("Password updated successfully");
      //     resetForm();
      //   }
      // } catch (error) {
      //   toast.error(error.response?.data?.message || "Update failed");
      // }
    },
  });

  return (
    <form
      onSubmit={formik.handleSubmit}
      className="flex flex-col justify-start items-start gap-4 w-full h-screen"
    >
      {/* Old Password */}
      <Input
        label="Old Password"
        type="password"
        color={false}
        name="oldPassword"
        value={formik.values.oldPassword}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />
      {formik.touched.oldPassword && formik.errors.oldPassword && (
        <p className="text-red-500 text-sm -mt-2">
          {formik.errors.oldPassword}
        </p>
      )}

      {/* New Password */}
      <Input
        label="New Password"
        type="password"
        color={false}
        name="newPassword"
        value={formik.values.newPassword}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />
      {formik.touched.newPassword && formik.errors.newPassword && (
        <p className="text-red-500 text-sm -mt-2">
          {formik.errors.newPassword}
        </p>
      )}

      {/* Confirm Password */}
      <Input
        label="Confirm Password"
        type="password"
        color={false}
        name="confirmPassword"
        value={formik.values.confirmPassword}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />
      {formik.touched.confirmPassword && formik.errors.confirmPassword && (
        <p className="text-red-500 text-sm -mt-2">
          {formik.errors.confirmPassword}
        </p>
      )}

      {/* Submit Button */}
      <Button type="submit" label="Save Changes" Icon={HiOutlineCheckCircle} />
    </form>
  );
}

export default ChangePassword;
